import React from "react";

const STEPS = [
  { n: 1, emoji: "🏪", title: "Pick a business", text: "Dog Walker, Babysitter, Craft Maker or Lawn Mower. Name it, design a logo, make flyers." },
  { n: 2, emoji: "🎮", title: "Take jobs & play", text: "Customers send requests. Set your price, do the mini-game, and collect the cash." },
  { n: 3, emoji: "⭐", title: "Win the reviews", text: "Do great work and stay safe to earn 5 stars. Riley is chasing the same customers!" },
];

const HowItWorks = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="landing-how">
    <div className="text-xs font-black uppercase tracking-widest text-amber-600 mb-2">How it works</div>
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 tracking-tight mb-8">Three steps to Top Boss</h2>
    <div className="grid sm:grid-cols-3 gap-5">
      {STEPS.map((s, i) => (
        <div
          key={s.n}
          className="bg-white rounded-3xl border-4 border-slate-200 p-6 card-3d animate-pop-in"
          style={{ animationDelay: `${i * 120}ms` }}
          data-testid={`landing-step-${s.n}`}
        >
          <div className="flex items-center justify-between mb-3">
            <span className="bg-slate-900 text-white font-display font-bold rounded-full w-9 h-9 flex items-center justify-center">{s.n}</span>
            <span className="text-4xl">{s.emoji}</span>
          </div>
          <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900">{s.title}</h3>
          <p className="text-sm sm:text-base text-slate-600 font-medium mt-2 leading-relaxed">{s.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorks;
